import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};
createReduxPromiseActionType(actionTypes, "LOGS_FETCH");
createReduxPromiseActionType(actionTypes, "LOG_COMMENT_ADD");
createReduxPromiseActionType(actionTypes, "LOGS_CLEAR");
createReduxPromiseActionType(actionTypes, "PAGE_LOAD_LOG_ADD");

export default actionTypes;
